module.exports = __webpack_public_path__ + "img/user_1.bc603e02.png";